import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Context } from '../shared/services/context.service';

@Injectable({
  providedIn: 'root'
})
export class SiteRCCService {

  constructor(
    private http: HttpClient,
  ) { }

  // private siteUrl = 'http://127.0.0.1:8080/Espace-patient';
  private siteUrl = 'https://www.rcc-pediatric.com/Espace-patient';

  public getSiteUrl () {
    return this.siteUrl;
  }

  addPatient(request: RCCRequest): Observable<RCCResponse> {
    return this.http.post<RCCResponse>(`${Context.apiUrl}siteRcc`, request);
  }

}

export interface RCCRequest {
  id: number,
  cabinet: string
}

export interface RCCResponse {
  id: number,
  message: string
}

